module.exports = __webpack_public_path__ + "img/resize-region.88599412.png";